import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

function Toast() {
  // Keep toasts pinned to the visible top of the screen. On iOS, position: fixed is
  // anchored to the layout viewport, so when the keyboard is open or the page is
  // scrolled the toast can drift out of view. Track the visual viewport's offset and
  // expose it as a CSS variable the toast container's `top` uses.
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }
    const update = () => {
      document.documentElement.style.setProperty("--vv-offset-top", `${vv.offsetTop}px`);
    };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
   />
  );
}

export default Toast;
